<template>
  <div class="login-page flex-col">
    <div class="login-container flex-col">
      <div class="login-header flex-col">
        <h1 class="login-title">常山陵园</h1>
        <p class="login-subtitle">用户登录</p>
      </div>
      
      <div class="login-form flex-col">
        <van-field
          v-model="form.username"
          name="username"
          label="用户名"
          placeholder="请输入用户名"
          :rules="[{ required: true, message: '请填写用户名' }]"
        />
        <van-field
          v-model="form.password"
          type="password"
          name="password"
          label="密码"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请填写密码' }]"
        />
        
        <div class="login-actions flex-col">
          <van-button
            type="primary"
            block
            :loading="loading"
            @click="handleLogin"
            class="login-btn"
          >
            登录
          </van-button>
          <van-button
            plain
            block
            @click="showRegister = true"
            class="register-btn"
          >
            注册账号
          </van-button>
        </div>
      </div>
    </div>

    <!-- 注册弹窗 -->
    <van-popup
      v-model="showRegister"
      position="center"
      :style="{ width: '90%', padding: '20px' }"
      round
    >
      <div class="register-popup flex-col">
        <h2 class="register-title">用户注册</h2>
        <van-field
          v-model="registerForm.username"
          name="username"
          label="用户名"
          placeholder="请输入用户名"
          :rules="[{ required: true, message: '请填写用户名' }]"
        />
        <van-field
          v-model="registerForm.password"
          type="password"
          name="password"
          label="密码"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请填写密码' }]"
        />
        <van-field
          v-model="registerForm.confirmPassword"
          type="password"
          name="confirmPassword"
          label="确认密码"
          placeholder="请再次输入密码"
          :rules="[
            { required: true, message: '请再次输入密码' },
            { validator: validateConfirmPassword, message: '两次密码输入不一致' }
          ]"
        />
        <van-field
          v-model="registerForm.contact"
          name="contact"
          label="联系方式"
          placeholder="请输入联系方式"
          :rules="[{ required: true, message: '请填写联系方式' }]"
        />
        
        <div class="register-actions flex-col">
          <van-button
            type="primary"
            block
            :loading="registerLoading"
            @click="handleRegister"
            class="register-submit-btn"
          >
            注册
          </van-button>
          <van-button
            plain
            block
            @click="showRegister = false"
            class="register-cancel-btn"
          >
            取消
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { login, register, setToken } from '@/api/auth'

export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      registerForm: {
        username: '',
        password: '',
        confirmPassword: '',
        contact: ''
      },
      loading: false,
      registerLoading: false,
      showRegister: false
    }
  },
  methods: {
    // 验证确认密码
    validateConfirmPassword(val) {
      return val === this.registerForm.password
    },
    
    // 登录
    async handleLogin() {
      if (!this.form.username || !this.form.password) {
        this.$toast('请填写完整的登录信息')
        return
      }
      
      this.loading = true
      try {
        const res = await login({
          username: this.form.username,
          password: this.form.password
        })
        
        if (res.code === 0 && res.data && res.data.token) {
          // 保存token
          setToken(res.data.token)
          this.$toast.success('登录成功')
          
          // 跳转到首页或之前访问的页面
          const redirect = this.$route.query.redirect || '/lanhu_shouye'
          this.$router.push(redirect)
        } else {
          this.$toast.fail(res.msg || '登录失败')
        }
      } catch (error) {
        console.error('登录错误:', error)
        this.$toast.fail(error.message || '登录失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    
    // 注册
    async handleRegister() {
      if (!this.registerForm.username || !this.registerForm.password || !this.registerForm.contact) {
        this.$toast('请填写完整的注册信息')
        return
      }
      
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.$toast('两次密码输入不一致')
        return
      }
      
      this.registerLoading = true
      try {
        const res = await register({
          username: this.registerForm.username,
          password: this.registerForm.password,
          contact: this.registerForm.contact
        })
        
        if (res.code === 0) {
          this.$toast.success('注册成功，请登录')
          this.showRegister = false
          // 自动填充用户名
          this.form.username = this.registerForm.username
          // 清空注册表单
          this.registerForm = {
            username: '',
            password: '',
            confirmPassword: '',
            contact: ''
          }
        } else {
          this.$toast.fail(res.msg || '注册失败')
        }
      } catch (error) {
        console.error('注册错误:', error)
        this.$toast.fail(error.message || '注册失败，请稍后重试')
      } finally {
        this.registerLoading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #ffffff;
  padding: 20px;
  justify-content: center;
  align-items: center;
}

.login-container {
  width: 100%;
  max-width: 420px;
  background: white;
  border-radius: 8px;
  padding: 50px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 149, 151, 0.1);
}

.login-header {
  align-items: center;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 2px solid rgba(0, 149, 151, 0.2);
}

.login-title {
  font-size: 36px;
  font-weight: bold;
  color: rgba(0, 149, 151, 1);
  margin: 0 0 12px 0;
  text-align: center;
  letter-spacing: 2px;
}

.login-subtitle {
  font-size: 16px;
  color: #666;
  margin: 0;
  text-align: center;
}

.login-form {
  gap: 24px;
}

/* 自定义输入框样式 */
.login-form >>> .van-cell {
  padding: 12px 16px;
  border: 1px solid rgba(0, 149, 151, 0.2);
  border-radius: 4px;
  margin-bottom: 16px;
}

.login-form >>> .van-cell:focus-within {
  border-color: rgba(0, 149, 151, 1);
}

.login-form >>> .van-field__label {
  color: rgba(0, 149, 151, 1);
  font-weight: 500;
  width: 80px;
}

.login-form >>> .van-field__control {
  color: #333;
}

.login-actions {
  margin-top: 30px;
  gap: 16px;
}

.login-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  background-color: rgba(0, 149, 151, 1);
  border: none;
  border-radius: 4px;
}

.login-btn:active {
  background-color: rgba(0, 149, 151, 0.8);
}

.register-btn {
  height: 48px;
  font-size: 16px;
  color: rgba(0, 149, 151, 1);
  border: 1px solid rgba(0, 149, 151, 1);
  border-radius: 4px;
  background: transparent;
}

.register-btn:active {
  background-color: rgba(0, 149, 151, 0.05);
}

.register-popup {
  gap: 20px;
  padding: 10px 0;
}

.register-title {
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  margin: 0 0 30px 0;
  color: rgba(0, 149, 151, 1);
  padding-bottom: 20px;
  border-bottom: 2px solid rgba(0, 149, 151, 0.2);
}

/* 注册弹窗中的输入框样式 */
.register-popup >>> .van-cell {
  padding: 12px 16px;
  border: 1px solid rgba(0, 149, 151, 0.2);
  border-radius: 4px;
  margin-bottom: 16px;
}

.register-popup >>> .van-cell:focus-within {
  border-color: rgba(0, 149, 151, 1);
}

.register-popup >>> .van-field__label {
  color: rgba(0, 149, 151, 1);
  font-weight: 500;
  width: 90px;
}

.register-popup >>> .van-field__control {
  color: #333;
}

.register-actions {
  margin-top: 30px;
  gap: 16px;
}

.register-submit-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  background-color: rgba(0, 149, 151, 1);
  border: none;
  border-radius: 4px;
}

.register-submit-btn:active {
  background-color: rgba(0, 149, 151, 0.8);
}

.register-cancel-btn {
  height: 48px;
  font-size: 16px;
  color: rgba(0, 149, 151, 1);
  border: 1px solid rgba(0, 149, 151, 1);
  border-radius: 4px;
  background: transparent;
}

.register-cancel-btn:active {
  background-color: rgba(0, 149, 151, 0.05);
}
</style>

